(() => {
  const page = document.querySelector('[data-policy-page]');
  if (!page || page.dataset.policyReady) return;
  page.dataset.policyReady = 'true';
  const contents = page.querySelector('.am-policy__contents');
  const desktop = window.matchMedia('(min-width: 990px)');
  const adaptContents = () => { contents.open = desktop.matches; };
  adaptContents();
  desktop.addEventListener('change', adaptContents);
  const links = [...contents.querySelectorAll('a[href^="#"]')];
  links.forEach(link => link.addEventListener('click', event => {
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    if (!desktop.matches) contents.open = false;
    history.replaceState(null, '', link.hash);
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: 'instant', block: 'start' });
    links.forEach(item => item.removeAttribute('aria-current'));
    link.setAttribute('aria-current', 'location');
  }));
})();
